import { overviewChartPalette } from "styles/theme";

export const engineeringKpiMapper = (raw) => {
    if (!raw) return []

    return [
        {
            label: "Total Drawings Planned",
            value:String(raw.totalDrawingsSubmitted || 0), //677
            bg: "#E7E7EB",
            iconBg: overviewChartPalette.indigo,
        },
        // {
        //     label: "Total Drawing Approved",
        //     value: String(raw.totalDrawingsApproved || 0),//190
        //     bg: "#DCFCE7",
        //     iconBg: "#3CD856",
        // },
        // {
        //     label: "Drawing Under Review",
        //     value: String(raw.drawingUnderReview || 0),
        //     bg: "#F3E8FF",
        //     iconBg: "#BF83FF",
        // },
        // {
        //     label: "Drawing Delayed",
        //     value: String(raw.drawingDelayed || 0),
        //     bg: "#FFE2E5",
        //     iconBg: "#FA5A7D",
        // },
        {
            label: "Drawings Received",
            value: String(raw.drawingsReceived || 0),
            bg: "#F3E8FF",
            iconBg: overviewChartPalette.teal,
        },
        {
            label: "Drawings Balance",
            value: String(raw.drawingsBalance || 0),
            bg: "#FFE2E5",
            iconBg: overviewChartPalette.coral,
        },
    ];
} 

export const engineeringIEStatusKpiMapper = (raw) => {
    if (!raw) return []

    return [
        {
            label: "Total Drawings Planned",
            value:String(raw.totalIEStatus || 0),
            bg: "#E7E7EB",
            iconBg: overviewChartPalette.indigo,
        },
        {
            label: "Drawings Approved",
            value: String(raw.totalIEApproved || 0),
            bg: "#F3E8FF",
            iconBg: overviewChartPalette.teal,
        },
        {
            label: "Drawings Under Approval",
            value: String(raw.totalIENotApproved || 0),
            bg: "#FFE2E5",
            iconBg: overviewChartPalette.amber,
        },
    ];
} 

const COLOR_PALETTE = [
    overviewChartPalette.teal,
    overviewChartPalette.cyan,
    overviewChartPalette.amber,
    overviewChartPalette.coral,
];

const BUCKET_MAPPING = [
    { key: "0-30", label: "0 to 30 days", color: COLOR_PALETTE[0] },
    { key: "31-60", label: "31 to 60 days", color: COLOR_PALETTE[1] },
    { key: "61-90", label: "61 to 90 days", color: COLOR_PALETTE[2] },
    { key: ">90", label: "> 90 days", color: COLOR_PALETTE[3] },
];

export const engineeringAgeingMapping = (rawData) => {
    const buckets = rawData?.buckets || [];


    const totalDrawings = rawData?.totalDrawingsSubmitted || 0;
    const approvedPercent = rawData?.approvedPercent || 0;

    const transformedData = BUCKET_MAPPING.map((staticItem) => {
        const apiBucket = buckets.find(b => b.label === staticItem.key);
        const count = apiBucket?.count || 0;
        const percentage =
            count > 0
                ? Math.floor((count / totalDrawings) * 100)
                : 0;

        return {
            label: staticItem.label,
            value: count,
            color: staticItem.color,
            percentage
        };
    });

    return {
        agingData: transformedData,
        totalDrawings,
        approvedPercent
    };
}

export const engineeringComponentsMapping = (rawData) => {
    const data = rawData || [];

    const updatedData = data.map((item) => {
        const total = item.dsTotal ?? 0;
        const received = item.dsReceived ?? 0;
        const receivedPercentage = item.dsComponentAverage ?? 0

        return {
            label: item.dsComponentName ?? "N/A",
            total,
            received,
            progressColor: receivedPercentage > 50 ? "#12AA5B" : "#1A73E8",
            receivedPercentage
        };
    });

    return updatedData
}
